import { Reveal } from "./Reveal";
import { Check } from "lucide-react";

const SAFETY_IMG =
  "https://images.unsplash.com/photo-1622612023350-b15f063eabe6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxjZXJ0aWZpZWQlMjBzYWZldHklMjBvZmZzaG9yZSUyMHdvcmtlciUyMGhlbG1ldHxlbnwwfHx8fDE3ODU1MjgwOTd8MA&ixlib=rb-4.1.0&q=85";

const certs = [
  "LOLER & PUWER compliant lifting operations",
  "OPITO BOSIET & MIST certified crews",
  "Offshore medical & fitness-to-work verified",
  "ISO 45001 safety management aligned",
  "Appointed-person lift planning on every job",
  "Fully inspected & colour-coded lifting gear",
];

export const Safety = () => (
  <section
    id="safety"
    data-testid="safety-section"
    className="w-full border-t border-white/10 bg-[#0A111D]"
  >
    <div className="grid grid-cols-1 lg:grid-cols-2">
      <div className="relative min-h-[420px] lg:min-h-[640px] overflow-hidden border-b lg:border-b-0 lg:border-r border-white/10">
        <img
          src={SAFETY_IMG}
          alt="Certified offshore worker in helmet and hi-vis"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-[#050B14]/40" />
        <div className="absolute bottom-8 left-8">
          <span className="font-mono text-xs tracking-[0.25em] uppercase text-accent">
            [ 004 — Safety & Compliance ]
          </span>
        </div>
      </div>

      <div className="px-6 md:px-12 py-16 md:py-24 flex flex-col justify-center">
        <Reveal>
          <h2 className="font-display text-5xl md:text-7xl leading-[0.9] tracking-tight mb-8">
            Everyone<br />
            <span className="text-accent">home safe.</span>
          </h2>
          <p className="text-lg text-[#94A3B8] font-light leading-relaxed max-w-xl mb-12">
            Offshore lifting is unforgiving. Our compliance isn&apos;t paperwork — it&apos;s
            the reason our crews go home in one piece, campaign after campaign.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8">
          {certs.map((c, i) => (
            <Reveal
              key={c}
              delay={i * 0.06}
              data-testid={`cert-${i}`}
              className="flex items-start gap-3 py-4 border-t border-white/10"
            >
              <Check className="text-accent shrink-0 mt-0.5" size={18} strokeWidth={2.5} />
              <span className="text-sm text-[#94A3B8]">{c}</span>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
